import {AxiosInstance, AxiosResponse} from "axios";
import {LegacyProduct} from "@/core/interfaces/Product";
import LaboratoryProduct from "@/core/interfaces/laboratory/LaboratoryProduct";

export type ProductIndexRequestParams = {
    [key: string]: number[] | boolean | string[];
    raw: boolean;
};

export default function (apiClient: AxiosInstance, hdsClient: AxiosInstance) {
    return {
        /**
         * Read the unit price (TTC) the officine sells a product at, as the
         * HDS resolves it — so a counter flow can show the very price the
         * credit will store. Null when the product has no price at all.
         *
         * @param id - The product (presentation) id.
         */
        async unitPrice(id: number): Promise<number | null> {
            return hdsClient.get(`products/${id}/price`)
                .then((response: AxiosResponse) => response.data.data.unit_price ?? null);
        },

        /**
         * Search for a product.
         *
         * @param searchTerm - The search term.
         * @param [size=20] - The number of results to return.
         */
        async search(searchTerm: string, size = 20): Promise<LegacyProduct[]> {
            const data = {
                keywords: searchTerm,
                size
            };

            return apiClient.post('products/search', data)
                .then(response => response.data.products);
        },
        /**
         * Get product presentation.
         *
         * @param id
         */
        getPresentation(id: number): Promise<LaboratoryProduct> {
            const params = {include: "price"};
            return apiClient.get(`product/presentation/detail/${id}`, {params})
                .then((response: AxiosResponse) => response.data.presentation);
        },

        /**
         * Get the product index.
         *
         * @template {T extends boolean} - If true, the product ids will be returned.
         *
         * @param {ProductIndexRequestParams} filterParams
         * @return {any}
         */
        index<T extends boolean>(filterParams: ProductIndexRequestParams): Promise<T extends true ? number[] : LaboratoryProduct[]> {
            return apiClient.get("/products", {params: filterParams})
                .then((response: AxiosResponse) => response.data.data);
        }
    };
}
